/**
 * Place puzzles — cities, landmarks, regions familiar to the audience. Bias
 * toward classic American + iconic international destinations (the era when
 * this audience was young, geography curricula were America + Europe heavy).
 */
export const PLACES = [
  'NEW YORK CITY',
  'SAN FRANCISCO',
  'LOS ANGELES',
  'NEW ORLEANS',
  'NASHVILLE TENNESSEE',
  'PHILADELPHIA',
  'BOSTON HARBOR',
  'CAPE COD',
  'NIAGARA FALLS',
  'GRAND CANYON',
  'YELLOWSTONE PARK',
  'YOSEMITE VALLEY',
  'MOUNT RUSHMORE',
  'GOLDEN GATE BRIDGE',
  'STATUE OF LIBERTY',
  'EMPIRE STATE BUILDING',
  'BROOKLYN BRIDGE',
  'CENTRAL PARK',
  'TIMES SQUARE',
  'WALL STREET',
  'FIFTH AVENUE',
  'WASHINGTON MONUMENT',
  'LINCOLN MEMORIAL',
  'WHITE HOUSE',
  'CAPITOL HILL',
  'KEY WEST FLORIDA',
  'MARTHAS VINEYARD',
  'MACKINAC ISLAND',
  'SAVANNAH GEORGIA',
  'CHARLESTON HARBOR',
  'COLONIAL WILLIAMSBURG',
  'GETTYSBURG BATTLEFIELD',
  'INDEPENDENCE HALL',
  'OLD FAITHFUL',
  'CRATER LAKE',
  'GREAT SMOKY MOUNTAINS',
  'BLUE RIDGE PARKWAY',
  'MISSISSIPPI RIVER',
  'PIKES PEAK',
  'DENALI NATIONAL PARK',
  'PARIS FRANCE',
  'LONDON ENGLAND',
  'ROME ITALY',
  'VENICE ITALY',
  'VIENNA AUSTRIA',
  'EIFFEL TOWER',
  'BIG BEN',
  'BUCKINGHAM PALACE',
  'TOWER OF LONDON',
  'WESTMINSTER ABBEY',
  'NOTRE DAME CATHEDRAL',
  'TRAFALGAR SQUARE',
  'PIAZZA SAN MARCO',
  'THE LOUVRE MUSEUM',
  'THE VATICAN',
  'SISTINE CHAPEL',
  'LEANING TOWER OF PISA',
  'COLOSSEUM IN ROME',
  'ACROPOLIS OF ATHENS',
  'BERLIN GERMANY',
  'AMSTERDAM HOLLAND',
  'EDINBURGH SCOTLAND',
  'DUBLIN IRELAND',
  'SWISS ALPS',
  'BLACK FOREST',
  'GREEK ISLANDS',
  'FRENCH RIVIERA',
  'IRISH COUNTRYSIDE',
  'SCOTTISH HIGHLANDS',
  'HAWAIIAN ISLANDS',
  'CARIBBEAN SEA',
  'PUERTO RICO',
  'BANFF NATIONAL PARK',
  'QUEBEC CITY',
  'PRINCE EDWARD ISLAND',
  'BUENOS AIRES',
  'RIO DE JANEIRO',
  'TOKYO JAPAN',
  'SYDNEY AUSTRALIA',
  'CAIRO EGYPT',
  'GREAT WALL OF CHINA',
  'TAJ MAHAL',
  'AYERS ROCK',
  'KILIMANJARO',
] as const;
